
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Seatercarrentalinpune() {



    const cardData =
    {
        keyword: 'Seater Car on Rent in Pune',
        heading: 'Meghana Cab : Seater Car on Rent in Pune',
        headingDescription: 'Meghana Cab offers Seater Car on Rent in Pune, ideal for group travel, family trips, and corporate outings. Whether you need a 7-seater, 9-seater, or 13-seater vehicle, we provide spacious, clean, and well-maintained cars equipped with modern amenities for a comfortable journey. Our trained drivers ensure safety, punctuality, and smooth travel across Pune and beyond. Enjoy affordable pricing, flexible booking options, and 24/7 support. Book your seater car on rent in Pune with Meghana Cab for a reliable and enjoyable travel experience.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "An exceptional collection of over 20,000 Indian artifacts curated by Dr. Dinkar Kelkar, this museum showcases sculptures, utensils, musical instruments, weapons, and everyday objects from various eras. It's a deep dive into India's folk and royal heritage. 🏺"
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Also known as the Japanese Garden, this beautifully landscaped oasis draws inspiration from Japan’s Korakuen Garden. With flowing water channels, koi ponds, manicured lawns, and tranquil paths, it’s a peaceful escape within the city. 🌸"
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A serene and scenic dam just outside Pune, perfect for evening drives, roadside snacks, and watching sunsets. It’s also a gateway to the Sinhagad Fort trek, offering a blend of nature and relaxation. 🌊"
  },
  {
    "title": "Fergusson College Road",
    "description": "A bustling street at the heart of Pune’s student culture, filled with cafes, bookstores, boutiques, and street food. It’s the perfect place to soak in local life and enjoy an energetic vibe. ☕"
  },
  {
    "title": "Sinhagad Fort",
    "description": "A legendary Maratha fort perched on a cliff about 30 km from the city. Known for the bravery of Tanaji Malusare, it’s a favorite among trekkers and history lovers. Enjoy local dishes like zunka bhakri at the summit. 🏞️"
  },
  {
    "title": "Lal Mahal",
    "description": "Built in the 1630s by Shahaji Bhosale, this reconstructed red palace was the childhood home of Chhatrapati Shivaji Maharaj. It displays murals, artifacts, and scenes from Shivaji’s life, preserving his early legacy. 🔴"
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century basalt rock-cut temple dedicated to Lord Shiva. Located centrally on Jangli Maharaj Road, the temple is peaceful, atmospheric, and known for its monolithic architecture and ancient sanctity. 🕉️"
  },
  {
    "title": "Aga Khan Palace",
    "description": "A monument of national importance, this palace served as a prison for Mahatma Gandhi, Kasturba Gandhi, and others during the Quit India Movement. Surrounded by well-kept gardens, it also features a memorial museum. 🕊️"
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Situated in Koregaon Park, this global wellness destination offers meditation sessions, spa therapies, and lush Zen gardens. A peaceful retreat attracting visitors from around the world. 🌿"
  },
  {
    "title": "Shaniwar Wada",
    "description": "Once the seat of the Peshwas of the Maratha Empire, this 18th-century fort complex is famous for its architectural grandeur, mysterious tales, and the iconic light and sound show held each evening. 🌆"
  }
],

"services": [
    {
        "name": "7-Seater Car Rental Pune",
        "description": "Meghana Cab offers 7-seater car rentals in Pune, ideal for families and small groups. Enjoy a spacious, comfortable ride with ample room for luggage and passengers."
    },
    {
        "name": "9-Seater SUV on Rent Pune",
        "description": "Travel in style and comfort with our 9-seater SUV rental in Pune. Perfect for outstation trips, group tours, and special events with plenty of space and power."
    },
    {
        "name": "12-Seater Tempo or Car Hire Pune",
        "description": "Hire 12-seater vehicles in Pune for larger group travel. Meghana Cab provides comfortable and reliable tempos or MUVs for group outings, corporate trips, or religious tours."
    },
    {
        "name": "Group Travel Car Rental Pune",
        "description": "Planning group travel from Pune? Meghana Cab offers affordable and reliable group car rental options, ensuring a hassle-free journey with professional drivers."
    },
    {
        "name": "Car Rental for Weddings Pune",
        "description": "Book spacious cars for wedding guest transportation in Pune with Meghana Cab. Our wedding rental services include luxury and multi-seater options for a stylish experience."
    },
    {
        "name": "Event Travel Seater Cars Pune",
        "description": "Travel to any event in a group with Meghana Cab’s event travel seater cars in Pune. Ideal for functions, parties, and corporate gatherings with group mobility solutions."
    },
    {
        "name": "SUV Hire for Group Pune",
        "description": "Hire premium SUVs for group travel in Pune. Meghana Cab offers clean, air-conditioned SUVs for comfortable long drives and local sightseeing with your group."
    },
    {
        "name": "Seater Taxi for Outstation Pune",
        "description": "Book seater taxis for outstation trips from Pune. Meghana Cab provides safe and spacious vehicles for family vacations, pilgrimages, and business travel."
    },
    {
        "name": "Car with Driver for Group Pune",
        "description": "Rent group cars in Pune with experienced drivers. Meghana Cab offers driver-included car rental for a smooth and stress-free group travel experience."
    },
    {
        "name": "MUV Rental Pune",
        "description": "Choose Meghana Cab’s MUV rentals in Pune for group travel needs. Our Multi Utility Vehicles offer extra space, comfort, and great performance for long or short journeys."
    },
    {
        "name": "Budget Seater Cars Pune",
        "description": "Looking for an affordable option for group travel? Meghana Cab offers budget-friendly seater cars in Pune without compromising on safety or comfort."
    },
    {
        "name": "Family Trip Car Rental Pune",
        "description": "Planning a family getaway? Meghana Cab offers spacious, well-maintained cars in Pune perfect for weekend escapes, city tours, or long vacations with loved ones."
    },
    {
        "name": "Corporate Group Car Rental Pune",
        "description": "Meghana Cab provides group travel solutions for corporate teams in Pune. Our fleet includes multi-seater vehicles for team outings, client visits, or event logistics."
    },
    {
        "name": "Online Seater Car Booking Pune",
        "description": "Book your seater car online with ease through Meghana Cab’s user-friendly platform. Check availability, compare options, and confirm your ride instantly."
    },
    {
        "name": "Seater Cab for Picnics Pune",
        "description": "Make your picnic plans smoother with Meghana Cab’s seater cab rentals in Pune. Enjoy a day out with your group in spacious and comfortable vehicles."
    }
],

"tableData": [
    ["7-Seater Car Rental Pune", "9-Seater SUV on Rent Pune"],
    ["12-Seater Tempo or Car Hire Pune", "Group Travel Car Rental Pune"],
    ["Car Rental for Weddings Pune", "Event Travel Seater Cars Pune"],
    ["SUV Hire for Group Pune", "Seater Taxi for Outstation Pune"],
    ["Car with Driver for Group Pune", "MUV Rental Pune"],
    ["Budget Seater Cars Pune", "Family Trip Car Rental Pune"],
    ["Corporate Group Car Rental Pune", "Online Seater Car Booking Pune"],
    ["Seater Cab for Picnics Pune", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Comfortable Seater Car on Rent in Pune",
        "WhyChoosedescription": "Meghana Cab provides a wide range of seater cars on rent in Pune, ideal for family trips, group outings, corporate travel, and special occasions. Choose from 5, 7, 9, 12, or 17-seater options based on your group size."
    },
    {
        "WhyChooseheading": "Multiple Seating Options Available",
        "WhyChoosedescription": "Whether you need a compact 5-seater or a spacious 17-seater Tempo Traveller, Meghana Cab offers flexible options for every requirement. Perfect for small to large groups."
    },
    {
        "WhyChooseheading": "Well-Maintained and Clean Vehicles",
        "WhyChoosedescription": "All our seater cars are regularly maintained, fully sanitized, and equipped with features like air conditioning, seat belts, and GPS tracking to ensure a safe and comfortable ride."
    },
    {
        "WhyChooseheading": "Professional Drivers for Group Travel",
        "WhyChoosedescription": "Our drivers are experienced, courteous, and trained for group travel. They ensure a smooth, punctual, and enjoyable journey no matter the destination."
    },
    {
        "WhyChooseheading": "Affordable Rental Packages",
        "WhyChoosedescription": "Meghana Cab offers competitive pricing for seater car rentals in Pune with no hidden charges. Choose from hourly, daily, or per-kilometer packages that suit your travel budget."
    },
    {
        "WhyChooseheading": "Ideal for All Occasions",
        "WhyChoosedescription": "Our seater cars are perfect for weddings, airport transfers, outstation tours, pilgrimage trips, and weekend getaways. We tailor the rental experience to match your event or purpose."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
        "WhyChoosedescription": "Need a seater car early morning or late at night? Meghana Cab operates round-the-clock to ensure you get the vehicle you need, whenever you need it."
    },
    {
        "WhyChooseheading": "Easy Booking and Customer Support",
        "WhyChoosedescription": "Book your seater car on rent in Pune effortlessly via our website or mobile app. Our support team is always ready to help you with your bookings and any special requirements."
    }
]




























    }

const faqData = [
    {
        question: "How can I rent a seater car in Pune with Meghana Cab?",
        answer: "You can rent a seater car in Pune by calling Meghana Cab at +91 9075462128 or booking online through our website."
    },
    {
        question: "What seater options are available for car rental in Pune?",
        answer: "We offer various options including 4-seater sedans, 6-7 seater SUVs, and 12-17 seater tempo travellers to suit your group size."
    },
    {
        question: "Are your seater rental cars available with drivers?",
        answer: "Yes, all our rental vehicles come with professional and experienced drivers for a safe and comfortable journey."
    },
    {
        question: "Can I rent a seater car for local and outstation trips?",
        answer: "Absolutely! Our seater cars are available for both local city use and outstation travel from Pune."
    },
    {
        question: "Are the vehicles clean and well-maintained?",
        answer: "Yes, all our cars are regularly cleaned and maintained to provide you with a comfortable and hygienic travel experience."
    },
    {
        question: "Can I book a seater car on rent for a full day in Pune?",
        answer: "Yes, we offer flexible rental options including hourly, half-day, full-day, and multi-day packages."
    },
    {
        question: "Are tolls, parking, and fuel included in the rental charges?",
        answer: "Toll and parking charges are extra. Fuel charges depend on your rental package and will be shared at the time of booking."
    },
    {
        question: "Do you provide doorstep pickup and drop with the rented car?",
        answer: "Yes, we offer convenient pickup and drop services at your preferred location in Pune."
    },
    {
        question: "What payment methods are accepted for seater car rental?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments for your convenience."
    },
    {
        question: "How can I contact Meghana Cab for renting a seater car in Pune?",
        answer: "To book or inquire, call Meghana Cab at +91 9075462128. Our team is available 24/7 to assist you."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Amit Shukla',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We hired a 7-seater SUV from Meghana Cab for our Pune weekend trip. The vehicle was comfortable and the driver was very cooperative.”',
    },
    {
        name: 'Mrs. Manasi Bhide',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab provided us with a 12-seater tempo traveller for a family function. It was clean, spacious, and arrived on time. Highly recommend!”',
    },
];





















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Seater Car on Rent in Pune",
  "image": "https://www.meghanacabs.com/assets/images/seater-car-rent-pune.jpg",
  "description": "Rent 7, 9, and 12 seater cars in Pune with Meghana Cabs for group travel, weddings, corporate events, and outstation trips. Affordable seater car rental with driver available.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5350"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/seater-car-rent-pune"
  }
};







    return (
        <div>
<Helmet>
  <title>Seater Car on Rent in Pune | Group & Family Car Rental | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Rent 7, 9, and 12 seater cars in Pune with Meghana Cabs for group travel, weddings, corporate events, and outstation trips. Affordable seater car rental with driver available." 
  />
  <meta 
    name="keywords" 
    content="7-Seater Car Rental Pune, 9-Seater SUV on Rent Pune, 12-Seater Tempo or Car Hire Pune, Group Travel Car Rental Pune, Car Rental for Weddings Pune, Event Travel Seater Cars Pune, SUV Hire for Group Pune, Seater Taxi for Outstation Pune, Car with Driver for Group Pune, MUV Rental Pune, Budget Seater Cars Pune, Family Trip Car Rental Pune, Corporate Group Car Rental Pune, Online Seater Car Booking Pune, Seater Cab for Picnics Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/17.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Seatercarrentalinpune;